import React, { useState, useEffect, memo } from "react";
import DeliveryHead from "../delivery/DeliveryHead";
import { Grid, Container, Tooltip } from "@mui/material";
import van from "../../../assets/images/van.png";
import signature from "../../../assets/images/signature.png";
import OrderInPDF from "./OrderInPDF";
import { useSearchParams } from "react-router-dom";
import {
  OrderLabelMain,
  OrderBox,
  OrderImage,
  OrderLink,
  OrderFrom,
  OrderTo,
  Notes,
  CustomerSec,
  ButtomMain,
  PDFButtomMain,
  PDFButtom,
} from "./styles/OrderLabelStyle";
import { toast } from "react-hot-toast";
import Loader from "../../shared/loader";
import { GetSingleOrder } from "../../../services/orders/Orders";
// import GetSingleOrder from "../../../services/orders/Orders";
// import { PDFViewer } from "@react-pdf/renderer";

const OrderLabel = () => {
  const [loading, setLoading] = useState(false);
  const [OrderData, setOrderData] = useState([]);
  const [searchParams] = useSearchParams();
  const id = searchParams.get("id");

  useEffect(() => {
    handleFetchOrders();
  }, [id]);

  const handleFetchOrders = async () => {
    await GetSingleOrder(id, setLoading, setOrderData, toast);
  };

  return (
    <>
      {loading && <Loader />}
      <DeliveryHead
        Value={66}
        BackLink="/my-orders"
        CenterText="Label"
        StepText="2 of 3"
        showBox={false}
        showLink={true}
      />
      {!loading && (
        <>
          <Container maxWidth="lg">
            <OrderLabelMain>
              <Grid container spacing={3}>
                <Grid item xs={12} sm={12} md={6} lg={6}>
                  {OrderData &&
                    OrderData?.stops &&
                    OrderData?.stops?.length > 0 && (
                      <>
                        <OrderBox>
                          <OrderImage>
                            <img src={van} alt="van" />
                          </OrderImage>
                          <OrderLink />
                          <OrderFrom>
                            <h6>From</h6>
                            <span>
                              {OrderData?.stops[0]?.contact_name || "N/A"}
                            </span>
                            <Tooltip
                              title={OrderData?.stops[0]?.location?.address}
                              arrow
                            >
                              <p>{OrderData?.stops[0]?.location?.address}</p>
                            </Tooltip>
                          </OrderFrom>
                          <OrderTo>
                            <h6>To</h6>
                            <span>
                              {OrderData?.stops[1]?.contact_name || "N/A"}
                            </span>
                            <Tooltip
                              title={OrderData?.stops[1]?.location?.address}
                              arrow
                            >
                              <p>{OrderData?.stops[1]?.location?.address}</p>
                            </Tooltip>
                          </OrderTo>
                          <Notes>
                            <h6>notes</h6>
                            <p>{OrderData.stops[0]?.notes || "N/A"}</p>
                          </Notes>
                          <OrderLink />
                          <CustomerSec>
                            <h6>Pickup customer</h6>
                            <div className="boxsec">
                              <h6>
                                {OrderData?.stops[0]?.contact_name || "N/A"}
                              </h6>
                              {/* <img
                                src={
                                  OrderData.stops[0]?.stop_confirmation
                                    ?.signature_url
                                }
                                alt="signature"
                              /> */}
                              <div
                                className="signature_image"
                                style={{
                                  backgroundImage: `url(${OrderData?.stops[0]?.stop_confirmation?.signature_url})`,
                                }}
                              ></div>
                            </div>
                          </CustomerSec>
                          <CustomerSec>
                            <h6>Drop-off customer</h6>
                            <div className="boxsec">
                              <h6>
                                {OrderData?.stops[1]?.contact_name || "N/A"}
                              </h6>
                              {/* <img
                                src={
                                  OrderData.stops[1]?.stop_confirmation
                                    ?.signature_url
                                }
                                alt="signature"
                              /> */}
                              <div
                                className="signature_image"
                                style={{
                                  backgroundImage: `url(${OrderData?.stops[1]?.stop_confirmation?.signature_url})`,
                                }}
                              ></div>
                            </div>
                          </CustomerSec>
                        </OrderBox>
                      </>
                    )}
                </Grid>
                <Grid item xs={12} sm={12} md={6} lg={6}>
                  <ButtomMain>
                    {!loading &&
                      OrderData &&
                      OrderData?.stops &&
                      OrderData?.stops?.length > 0 && (
                        <>
                          <PDFButtomMain
                            document={<OrderInPDF OrderData={OrderData} />}
                            fileName="order.pdf"
                          >
                            {({ blob, url, loading, error }) =>
                              loading ? "Generating PDF..." : "Download as PDF"
                            }
                          </PDFButtomMain>
                          {/* <PDFButtom className="docx">
                            Download as .docx
                          </PDFButtom> */}
                        </>
                      )}
                  </ButtomMain>
                </Grid>
              </Grid>
            </OrderLabelMain>
          </Container>
          {/* <PDFViewer>
            <OrderInPDF OrderData={OrderData} />
          </PDFViewer> */}
        </>
      )}
    </>
  );
};

export default memo(OrderLabel);
